module.exports = __webpack_public_path__ + "static/media/recommendation6.0bd83b90.jpg";